import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../styles/theme";
import GeographyChart from "../../../components/GeographyChart";
import BarChart from "../../../components/BarChart";
import StatBox from "../../../components/StatBox";
import ProgressCircle from "../../../components/ProgressCircle";
import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const DashboardNoAdmin = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [datadis, setDataDis] = useState([]);
  const [dataStaff, setDataStaff] = useState([]);

  useEffect(() => {
   
        axios
          .get(`${BaseUrl}/api/getAllDistributorStaff`, {
            withCredentials: true,
           
          })
          .then((res) => {
            setDataDis(res.data.data);
          })
          .catch((err) => {});
          axios
          .get(`${BaseUrl}/api/getAllStaffCount`, {
            withCredentials: true,
          })
          .then((res) => {
            setDataStaff(res.data.data);
          })
          .catch((err) => {}); 
          axios
          .get(`${BaseUrl}/api/getAllDistributorStaff`, {
            withCredentials: true,
          })
          .then((res) => {});
    },[]);

  


  return (
    <div className="main-div">
      <h3 className="titlepage"> لوحة تحكم تطبيق ليرتنا كاش</h3>
      <Box m="5px 5px 0px 5px">
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gridAutoRows="140px"
          gap="20px"
        >
 
        </Box>
      </Box>
    </div>
  );
};

export default DashboardNoAdmin;
